import { Controller } from 'stimulus'
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['serviceItem', 'checkbox', 'button']

  connect() {
    this.serviceCategory = document.getElementById('service-category')
    this.resetServiceCategoryAnimation()

    this.filterServicesBasedOnCheckedRadio()
    this.highlightSelectedServiceContainers()
    this.verifyButtonEnabler()
    this.selectServiceItem()
  }

  resetServiceCategoryAnimation() {
    this.serviceCategory.addEventListener('animationend', () => {
      this.serviceCategory.style.opacity = 1
      this.serviceCategory.style.animation = 'none';
    }, { once: true })
  }

  reset() {
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked')

    if (checkedRadio) {
      checkedRadio.checked = false
    }
    this.filterServicesBasedOnCheckedRadio()

    this.serviceCategory.style.opacity = 0
    this.serviceCategory.style.animation = ''

    this.uncheckServices()
    this.verifyButtonEnabler()
  }

  selectServiceItem() {
    const selectedServiceItem = this.element.querySelector('.service-checkbox:checked')

    this.highlightSelectedServiceContainers()
    this.verifyButtonEnabler()

    const selectedCategory = document.querySelector('.service-category__item input[type="radio"]:checked')?.value

    document.querySelectorAll('.employees').forEach((employee) => {
      employee.style.display = 'none'

      if (employee.classList.contains(`employees--${selectedCategory}`)) {
        employee.style.display = '';
      }
    })

    const selectedServiceItemContainer = selectedServiceItem?.closest('label.service-container')

    if (selectedServiceItemContainer) {
      let serviceOptions = document.getElementById('step-service-options')
      serviceOptions?.remove()
    }

    if (selectedServiceItemContainer && selectedServiceItemContainer.dataset.serviceOptions == "true") {
      Rails.ajax({
        url: selectedServiceItemContainer.dataset.serviceOptionsUrl,
        type: "GET",
        success: function(result) {
          let serviceOptions = document.getElementById('step-service-options')
          serviceOptions?.remove()

          let firstStep = document.getElementById('step-initial')
          firstStep.insertAdjacentHTML('afterend', result["html"])
        },
        error: function() {
          alert('Oh oh! Something went wrong, we are currently fixing this issue! Please refresh and try again in just a bit...')
        }
      })
    }
  }

  selectServiceOption() {
    let checkbox = event.currentTarget.querySelector('.service-option')
    checkbox.checked = !checkbox.checked
    this.highlightSelectedServiceContainers()
    this.verifyButtonEnabler()
    this.prepareServiceOptionSummary()
  }

  clearServiceOptions() {
    let serviceOptions = document.querySelectorAll('.service-option')
    serviceOptions.forEach((element) => { element.checked = false })
    this.highlightSelectedServiceContainers()
    this.prepareServiceOptionSummary()
  }

  highlightSelectedServiceContainers() {
    this.checkboxTargets.forEach((element) => {
      let serviceContainer = element.closest(".service-container")
      serviceContainer.classList.toggle('selected', element.checked)
    })
  }

  prepareServiceOptionSummary() {
    let serviceSummary = document.getElementById('service-options-summary')
    let serviceOptionsSelected = [...document.querySelectorAll('.service-option')].some(checkbox => checkbox.checked)
    serviceSummary.style.display = (serviceOptionsSelected ? 'block' : 'none')
  }

  uncheckServices() {
    this.checkboxTargets.forEach((element) => { element.checked = false })
    this.highlightSelectedServiceContainers()
  }

  verifyButtonEnabler() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = !this.hasSelectedCheckboxes
    }
  }

  hideAllServiceItems() {
    this.serviceItemTargets.forEach((item) => {
      item.classList.add('hidden')
      item.style.animation = ''
      item.style.opacity = 0
    });

    const notice = document.getElementById("junior-notice");
    notice.style.display = "none";
  }

  filterServicesBasedOnCheckedRadio() {
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked');

    if (!checkedRadio) {
      this.hideAllServiceItems()
      return
    }

    const selectedCategory = checkedRadio.value;

    this.resetServiceCategoryAnimation()

    this.hideAllServiceItems()

    if (selectedCategory === 'master') {
      this.showServicesByCategory('master');
    // } else if (selectedCategory === 'junior') {
    //   const notice = document.getElementById("junior-notice");
    //   notice.style.display = "block";
    } else {
      this.showServicesByCategory(selectedCategory);
    }
  }

  filterServices(event) {
    this.uncheckServices()
    this.verifyButtonEnabler()
    const selectedRadio = event.target;

    if (!selectedRadio.checked) {
      this.hideAllServiceItems()
      return;
    }

    const selectedCategory = selectedRadio.value
    this.hideAllServiceItems()

    setTimeout(() => {
      this.showServicesByCategory(selectedCategory)
    }, 0)
  }

  showServicesByCategory(category) {
    const serviceCategory = (category == 'master') ? 'senior' : category

    // const notice = document.getElementById("junior-notice")
    // if (serviceCategory === 'junior') {
    //   notice.style.display = "block"
    // } else {
    //   notice.style.display = "none"

      this.serviceItemTargets.forEach((item) => {
        if (item.classList.contains(`service-category--${serviceCategory}`)) {
          item.classList.remove('hidden')

          item.addEventListener('animationend', () => {
            item.style.opacity = 1
            item.style.animation = 'none';
          }, { once: true })

          const price = item.querySelector('.price')

          price.innerHTML = `&euro;` + ((category === 'master')
            ? item.dataset.servicePricePremium
            : item.dataset.servicePrice)
        }
      })
    // }
  }

  get hasSelectedCheckboxes() {
    return this.checkboxTargets.filter(checkbox => checkbox.checked).length
  }
}
